import type React from 'react'

export const labelStyle: React.CSSProperties = {
  fontSize: 12.5,
  fontWeight: 600,
  color: '#374151',
  marginBottom: 6,
  display: 'block',
}

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 10px',
  fontSize: 13,
  border: '1px solid #D1D5DB',
  borderRadius: 8,
  outline: 'none',
  color: '#111827',
  background: '#fff',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
}

export const inputErrorStyle: React.CSSProperties = {
  borderColor: '#DC2626',
}

export const errorStyle: React.CSSProperties = {
  fontSize: 11.5,
  color: '#DC2626',
  margin: '4px 0 0',
}

export const helperStyle: React.CSSProperties = {
  fontSize: 11.5,
  color: '#9CA3AF',
  margin: '4px 0 0',
}
